import { isAccordionOpen } from '../../helpers/openAccordion'

const getNavigationList = () => [
  {
    text: 'About This Product',
    name: 'description',
    toElement: '#pdp-description'
  },
  {
    text: 'Nutritional Info',
    name: 'nutrition',
    toElement: '#nutritional-info'
  },
  {
    text: 'More Details',
    name: 'cnet',
    toElement: '#cnet-accordion'
  },
  {
    text: 'Reviews',
    name: 'review',
    toElement: '#reviews'
  },
  {
    text: 'Questions & Answers',
    name: 'qanda',
    toElement: '#qanda'
  },
  {
    text: 'Special Offers',
    name: 'offers',
    toElement: '#special-offers-accordion'
  },
  {
    text: 'Bought Together',
    name: 'bundles',
    toElement: '#frequently-bought-together-accordion'
  }
]

const getToElement = (navList, name) => navList.find(navItem => navItem.name === name).toElement

const getInitialNavInfo = ({
  offers = [],
  bundles = [],
  reviews = [],
  isCNETContent = false,
  nutrition = {},
  FREQUENTY_BROUHT_TOGETHER,
  Q_AND_A
}) => {
  const isReviewOnPage = reviews.length > 0
  const isBundlesOnPage = bundles.length > 0
  const isOfferOnPage = offers.length > 0
  const isNutritionContent = nutrition?.nutritionInformation?.nutritionData.length > 0

  const navList = getNavigationList()
  const dynamicNavButton = FREQUENTY_BROUHT_TOGETHER && {
    bundles: {
      isOnPage: isBundlesOnPage,
      isOpen: isAccordionOpen(getToElement(navList, 'bundles'))
    }
  }

  const navButtons = {
    description: {
      isOnPage: true,
      isOpen: isAccordionOpen(getToElement(navList, 'description'))
    },
    nutrition: {
      isOnPage: isNutritionContent,
      isOpen: isAccordionOpen(getToElement(navList, 'nutrition'))
    },
    cnet: {
      isOnPage: isCNETContent,
      isOpen: isAccordionOpen(getToElement(navList, 'cnet'))
    },
    review: {
      isOnPage: isReviewOnPage,
      isOpen: isAccordionOpen(getToElement(navList, 'review'))
    },
    qanda: {
      isOnPage: Q_AND_A,
      isOpen: isAccordionOpen(getToElement(navList, 'qanda'))
    },
    offers: {
      isOnPage: isOfferOnPage,
      isOpen: isAccordionOpen(getToElement(navList, 'offers'))
    }
  }
  return { ...navButtons, ...dynamicNavButton }
}

export { getNavigationList, getInitialNavInfo }
